






















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../base/components/system/mixins";
import { ISortParameter } from "../../../../base/components/system";
import { TimeMeasure } from "../../../../base/utilities";
import { DomainRegistry } from "../../../domain";
import { EditableFormatSummary } from "../../../domain/editableFormat";
import { default as FormatSortSelector } from "./FormatSortSelector.vue";
import { default as FormatTableSelector } from "./FormatTableSelector.vue";
import { Directory } from "../../../../base/domain/drawing";

@Component({
  components: {
    FormatSortSelector,
    FormatTableSelector,
  }
})
export default class UnsynchronizedFormatsSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: false })
  isShown: boolean;

  isLoaded: boolean = false;
  isFormatLoading: boolean = false;
  selectedUnsynchronizedFormat: EditableFormatSummary = null;
  unsynchronizedFormats: EditableFormatSummary[] = [];
  sortedValues: EditableFormatSummary[] = [];
  sortParameter: ISortParameter = {
    order: "descending",
    property: "lastUpdateDateTime",
  };
  formatTree: Directory<number, EditableFormatSummary>[] = [];

  get isSelected(): boolean {
    return (!!this.editingSource && 0 < this.editingSource.length);
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  mounted(): void {
    if (this.isShown) {
      this.isLoaded = true;
      this.loadUnsynchronizedFormats();
    }
  }

  @Watch("isShown")
  onIsShownUpdated(newValue: boolean, oldValue: boolean): void {
    if (newValue && !this.isLoaded) {
      this.isLoaded = true;
      this.loadUnsynchronizedFormats();
    }
  }

  async loadUnsynchronizedFormats(): Promise<void> {
    this.isFormatLoading = true;
    this.unsynchronizedFormats = [];
    await this.loadFormatTree();
    await this.getUnsynchronizedFormats()
    .then(d => this.unsynchronizedFormats = d)
    .catch(e => {
      this.$error(
        "未同期" + this.formatNameWording + "取得失敗",
        "未同期" + this.formatNameWording + "を読み込めませんでした。",
        e
      );
    })
    .finally(() => this.isFormatLoading = false);
  }

  private getUnsynchronizedFormats(): Promise<EditableFormatSummary[]> {
    return TimeMeasure.logAsync(
      "未同期" + this.formatNameWording + "取得",
      async () => {
        const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
        return repository.getUnsynchronizedFormats();
      },
      "",
      TimeMeasure.debug
    );
  }

  private async loadFormatTree(): Promise<void> {
    const repository = DomainRegistry.instance.editableFormat.getFormatRepository();
    this.formatTree = await repository.getFormatTree();
  }

  onSortChanged(param: ISortParameter): void {
    this.sortParameter = param;
  }

  changeSelectedFormats(value: EditableFormatSummary[]): void {
    this.editingSource = value;
  }
}
